import {
  Component,
  Injectable,
  EventEmitter,
  ViewChild,
  ElementRef,
  Renderer2,
  Inject,
  Output,
  Input,
  NgModule,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DewService } from "../services/dew.service";
import { DewAuthService } from 'src/authentication/core/auth.service';
import { MainService } from "../services/main.services";
import * as _ from "lodash";
import { Config } from "../config";

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { CustomValidators } from "ng2-validation";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SignUpService } from "@app/services/api.signup.services";
import { ToastProvider } from "@app/Notification/Toast/toast.provider";

const password = new FormControl("", Validators.required);
const confirmPassword = new FormControl("", CustomValidators.equalTo(password));
const email = new FormControl("");

@Component({
  selector: "setPassword",
  templateUrl: "./setPassword.component.html",
  styleUrls: [],
})
export class setPassword {
  setPasswordForm: FormGroup;
  private submitted: boolean = false;
  showResetForm: boolean;
  notaryEmail: any;
  user: any = {};
  meetingLinkExpired: boolean;
  invalidLink: boolean;
  newPasswordHide = true;
  confirmPasswordHide = true;
  userNotActive = false
  inviteAlreadyUsed = false
  generatedSuccess = false
  guid: string;
  userId: string;
  responceEmail : any;
  type : any ;
  constructor(
    private route: ActivatedRoute,
    private dewService: DewService,
    private signup: SignUpService,
    public snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastProvider: ToastProvider,
  ) {
    var url = Config.ServiceBaseUrl;
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((queryparams) => {
      this.userId = queryparams.get("Id");
      this.guid = queryparams.get("guid");
    });
    this.CheckUserIdIsValid();
    this.setPasswordForm = this.formBuilder.group({
      email: email,
      newpassword: password,
      confirmpassword: confirmPassword,
    });
    this.setPasswordForm.reset();
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }

  CheckUserIdIsValid(){
    if(this.userId && this.guid){
      this.signup.vaildInviteCheck(this.userId, this.guid).subscribe(
        (response: any) => {
          if (response && response.response.length == 1) {
            if(response.response[0].isActive == true){
              this.responceEmail = response.response[0].email

              this.type = response.response[0].request
              if(this.type == 1 || this.type == 2){
                this.userNotActive = false
                this.inviteAlreadyUsed = false
              }else if(this.type == 7 || this.type == 9 || this.type == 4){
                this.inviteAlreadyUsed = true
              }else{
                this.userNotActive = true
              }

            }else{
              this.userNotActive = true
            }
          }
        }
      );
    }else{
      this.dewService.navigateToPage("/login", queryStrings);

    }
  }

  setPassword(){
    this.user.newpassword = this.setPasswordForm.value.newpassword;
    this.user.confirmpassword = this.setPasswordForm.value.confirmpassword;
    if(this.user.confirmpassword == this.user.newpassword){
      if(this.user.confirmpassword && this.user.newpassword)
      this.signup.setMemberPassword(this.userId, this.guid , this.user.newpassword).subscribe(
        (response: any) => {
          if (response && response.response == "Success") {
            var msg = 'Password has been generated successfully.';
            this.toastProvider.sendMessage(msg, 'success');
            // this.snackBar.open(msg, 'OK', {
            // duration: 5000,
            // });
            this.dewService.navigateToPage("/login", "");

          }
        }
      );
    }else{

    }
  }
  
  

  isFieldInvalid(field: string) {
    return (
      (!this.setPasswordForm.get(field).valid &&
        this.setPasswordForm.get(field).touched) ||
      (this.setPasswordForm.get(field).untouched && this.submitted)
    );
  }

  redirect() {
    var queryStrings = {};
    this.dewService.navigateToPage("/login", queryStrings);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
  }
}
function queryStrings(arg0: string, queryStrings: any) {
  throw new Error("Function not implemented.");
}

